import { Store } from 'redux';

import createInventory from './framework/presenter/createInventory';
import createPresenter from './framework/presenter/createPresenter';

interface AppProps {
  store: Store<any>;
}

const App = ({ store }: AppProps) => {
  const Presenter = createPresenter(createInventory(), store);
  return <Presenter />;
};

export default App;
